// extracted by mini-css-extract-plugin
export var alignCenter = "_bo-d";
export var bannerShown = "_bo-6";
export var buttonContent = "_bo-0";
export var cardList = "_bo-1";
export var centerContent = "_bo-2";
export var chevron = "_bo-3";
export var closePanelButton = "_bo-k";
export var conversationContextContainer = "_bo-l";
export var conversationDetailContainer = "_bo-4";
export var detailWrapper = "_bo-7";
export var dropdownButton = "_bo-e";
export var dropdownTitle = "_bo-9";
export var fullHeight = "_bo-5";
export var hidden = "_bo-a";
export var icon = "_bo-b";
export var mergeSuggestionWrapper = "_bo-m";
export var panel = "_bo-i";
export var portalButtonsWrapper = "_bo-c";
export var right = "_bo-j";
export var tableSummaryContainer = "_bo-8";
export var tableSummaryHeader = "_bo-g";
export var threeDotsButton = "_bo-f";
export var wide = "_bo-h";